<script>
import { mapGetters } from "vuex";
import { loader } from "@/common/mixins/mix_loader";
import { request } from "@/common/mixins/mix_helper";

export default {
  name: "shortcut_button",
  mixins: [loader, request],
  data() {
    return {};
  },
  methods: {
    onAllowUserUploadedFile() {
      this.$swal({
        title: "Perhatian",
        icon: "warning",
        text: "Anda yakin akan mengizinkan user bisa upload file ?",
        showCancelButton: true,
        confirmButtonText: "Yes",
      }).then(({ isConfirmed }) => {
        if (isConfirmed) {
          this.loading();
          this.API.post(this.URL.thread.is_upload, {
            threadid: this.getDialogActive.id,
            is_allow: 1,
          })
            .then(() => {
              this.$swal(
                "Success",
                "User telah diizinkan untuk upload file",
                "success"
              );
            })
            .catch(() => {
              this.$swal("ERROR", "", "error");
            })
            .finally(() => {
              this.loading(false);
            });
        }
      });
    },
  },
  computed: {
    ...mapGetters(["getDialogActive"]),
  },
};
</script>

<template>
  <div class="grid grid-cols-5 gap-1 py-2 px-3">
    <div
      @click.stop.prevent="onAllowUserUploadedFile"
      class="border flex content-center justify-center rounded rw-text-3 cursor-pointer"
      v-b-tooltip.hover
      title="Izinkan user upload file"
    >
      <span class="material-symbols-outlined leading-9"
        >drive_folder_upload</span
      >
    </div>
    <div
      class="border flex content-center justify-center rounded bg-gray-200 cursor-not-allowed"
      v-for="i in 3"
      v-b-tooltip.hover
      title="Soon"
      :key="i"
    >
      <span class="material-symbols-outlined leading-9">lock</span>
    </div>
    <div
      class="border text-center rounded bg-gray-200 cursor-not-allowed"
      v-b-tooltip.hover
      title="Soon"
    >
      <span class="material-symbols-outlined leading-9">more_horiz</span>
    </div>
  </div>
</template>

<style scoped></style>
